import React from 'react'
import './style.css'
import { generator } from '@/utils/NumbersUtils'

const TagList = ({ items, className = '' }) => {
    if (!items || items.length === 0) return null

    return (
        <div className={`tag-list ${className}`}>
            {items.mapWithKey((item, index) => (
                <span key={item.key} className="tag-item">{item.value}</span>
            ))}
        </div>  
    )
}

export default TagList

